<template>
  <footer class="container-fluid footer-main py-2 d-print-none">
    <div class="float-right">
      <ScrollTop :threshold="200" class="custom-scrolltop" icon="pi pi-arrow-up" />
    </div>
    <div class="container">
      <div class="d-flex flex-column flex-md-row justify-content-between py-2">
        <div class="d-flex mt-md-1">
          <a href="https://eeas.europa.eu" target="_blank"><img src="../../assets/eeas/img/eeas-logo@2x.png" alt="EEAS" height="32" class="mt-1 me-2 me-md-3"></a>
          <div>
            <a href="https://eeas.europa.eu" target="_blank" class="underlineLink">European Union External Action</a><br>
            <small style="color: #adb5bd" v-tooltip.top="'Version ' + version +' &nbsp;&nbsp;-&nbsp;&nbsp; ' + buildTime">Goalkeeper © EEAS IT Division - {{ new Date().getFullYear() }}</small>
          </div>
        </div>
        <div class="pt-3 pt-md-0">
          <div class="mb-2">
            <a href="mailto:goalkeeper.schoolmaster@eeas.europa.eu" class="underlineLink-wrapper text-decoration-none mb-2">
              <span class="material-icons-rounded fs-14 me-2">mail</span><span class="underlineLink">goalkeeper.schoolmaster@eeas.europa.eu</span></a>
          </div>
          <a href="mailto:goalkeeper.registrar@eeas.europa.eu" class="underlineLink-wrapper text-decoration-none">
            <span class="material-icons-rounded fs-14 me-2">mail</span><span class="underlineLink">goalkeeper.registrar@eeas.europa.eu</span></a>
        </div>
        <div class="pt-4 pt-md-3">
          <a :href="privacyStatementUrl" target="_blank" class="underlineLink me-4 py-2">{{ privacyStatementName }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script src="./EeasFooter.ts"></script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
::v-deep(.custom-scrolltop) {
  width: 2rem;
  height: 2rem;
  border-radius: 4px;

  &.p-link {
    background-color: #0d74c8; //var(--primary-color);
  }
  &.p-link:hover {
    background-color: var(--primary-color);
  }

  .p-scrolltop-icon {
    font-size: 1rem;
    color: var(--primary-color-text);
  }
}
/* =============
   FOOTER
============= */
$gray-100: #f8f9fa !default;
$gray-200: #e9ecef !default;
$gray-300: #dee2e6 !default;
$gray-400: #ced4da !default;
$gray-500: #adb5bd !default;
$gray-600: #6c757d !default;
$gray-700: #495057 !default;
$gray-800: #343a40 !default;
$primary:    #1976d2 !default;

.footer-main {
  position: relative;
  margin: 0 ;
  background: rgb(13,116,200);
  background: linear-gradient(90deg, rgba(13,116,200,1) 0%, rgba(65,164,244,1) 100%);
  color: white;
  font-size: 0.835rem;

  a {
    color: #bddaf3; // #ced4da;
    &:hover {
      color: white;
    }
    &.text-muted {
      color: darken($primary, 10%);
      &:hover {
         color: white !important;
       }
    }
  }
  .material-icons-rounded {
    color: #bddaf3;
  }
  .details-wrapper {
    position: absolute;
    bottom: 43px;
    background-color: white;
    padding: 1rem;
    box-shadow: rgb(0 0 0 / 20%) 0 5px 20px 0 !important;
  }

}
</style>